<template>
  <router-view @snackbarevent="updateSnackbar"></router-view>
</template>
<script>
export default {
  methods: {
    updateSnackbar(message) {
      this.$emit("snackbarevent", message);
    }
  }
};
</script>
